import { BaseFormHelperText } from '../BaseFormHelperText/BaseFormHelperText';
import { FormErrorMessageProps } from './FormErrorMessage.types';
import css from './FormErrorMessage.module.scss';
import { useField } from 'formik';
import { memo } from 'react';

/**
 * The error message that displays under certain controls.
 *
 * @note This error message requires `Formik` context to function.
 *
 * @param name - {@link FormErrorMessageProps.name name} description.
 */
const FormErrorMessage = memo(({
    name,
}: FormErrorMessageProps) => {
    const [, meta] = useField(name);

    return (
        !!meta.error && meta.touched ? (
            <BaseFormHelperText
                classes={{
                    root: css.errorMessage,
                }}
            >
                {meta.error}
            </BaseFormHelperText>
        ) : (
            null
        )
    );
});

export default FormErrorMessage;